//Uhrzeit laden
//Marks

var xmlHttp;
function srvTime(){
    try {
        //FF, Opera, Safari, Chrome
        xmlHttp = new XMLHttpRequest();
    }
    catch (err1) {
        //IE
        try {
            xmlHttp = new ActiveXObject('Msxml2.XMLHTTP');
        }
        catch (err2) {
            try {
                xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
            }
            catch (eerr3) {
                //AJAX not supported, use CPU time.
                alert("AJAX not supported");
            }
        }
    }
    xmlHttp.open('HEAD',window.location.href.toString(),false);
    xmlHttp.setRequestHeader("Content-Type", "text/html");
    xmlHttp.send('');
    return xmlHttp.getResponseHeader("Date");
}

//var st = srvTime();
//var date = new Date(st);
//alert(date);

//Uhrzeit Ende
function getDropTimeClubPlus5sec() {
  const now = new Date();              // aktuelles Datum & Zeit :contentReference[oaicite:0]{index=0}
  const future = new Date(now.getTime() + 5000); // + 5000 Millisekunden = + 5 Sekunden :contentReference[oaicite:1]{index=1}

  const pad = (n) => n.toString().padStart(2, '0');

  const month = pad(future.getMonth() + 1); // Monate sind 0–11 :contentReference[oaicite:2]{index=2}
  const day   = pad(future.getDate());
  const year  = future.getFullYear();
  const hours = pad(future.getHours());
  const mins  = pad(future.getMinutes());
  const secs  = pad(future.getSeconds());

  return `${month}/${day}/${year} ${hours}:${mins}:${secs}`;
}

//Prüfen ob man auf der falschen Seite ist   
if(document.getElementById("ausblenden") != null) {
  
            //Für reguläre Teilnehmer
                      var DropTimeClub = '05/03/2026 10:00:00';
                      var TextUeberschrift="<h2><strong>Bis zum </strong><em><strong>Drop No. 8</strong></em><strong><br/>am 3. Mai um 10.00 Uhr <br/>sind es noch …</strong><br/></h2>";
            
            //Für Broadcast Teilnehmer
                      const urlParams = new URLSearchParams(window.location.search);
                      const myParam = urlParams.get('id');
                      
    if(myParam=="broadcast" || sessionStorage.getItem("broadcast") == 1) 
                      {
                        sessionStorage.setItem("broadcast", 1);
                        var DropTimeClub = '05/03/2026 09:45:00';                       
                        var TextUeberschrift="<h2><strong>Bis zum </strong><em><strong>Drop No. 8</strong></em><strong><br/>am 3. Mai um 9.45 Uhr <br/>sind es noch …</strong><br/></h2>";
                      }

    if(myParam=="Mark") 
                      {                      
                        //sessionStorage.setItem("broadcast", 1);            
                        DropTimeClub = new Date(Date.now());
                        DropTimeClub.getSeconds()
                        DropTimeClub.setSeconds(DropTimeClub.getSeconds()+3);                        
                        var DropTimeClub = getDropTimeClubPlus5sec();  
                        var TextUeberschrift="<h2><strong>Bis zum </strong><em><strong>Drop No. 8</strong></em><strong><br/>am 3. Mai um 10.00 Uhr <br/>sind es noch …</strong><br/></h2>";
                
                      }
            
           // alert(sessionStorage.getItem("broadcast"));
  
            //Setzt jeden Button auf display none vor der Zeit
 const knoepfe = [];                      
                      var links = document.getElementsByTagName('a');
                      var zaehler = -1;
                      
                      for(var i = 0; i< links.length; i++){
                        
                        if (links[i].href=="https://winecliq.de/products/drop-no-8-2023-griesel-compagnie-rose-extra-brut")
                        {
                          
                          zaehler = zaehler + 1;
                          knoepfe[zaehler] = i;    
                        }
                      }

          
          //aktuelles Datum
                    var DatumLadung=new Date();
          
          //Wenn Cliq schon Zeit abgelaufen
                      if(DatumLadung>= new Date(DropTimeClub)) {
                      
                       //window.location.href = "/products/wine-cliq-drop-no-4";
                        //Die Funktion bewirkt, dass wenn man auf der Produktseite ist, man immer wieder dort neu geleitet wird Endlosschleife!!
                      }
          
          //Wenn Cliq noch in Zukunft
                      if(new Date() < new Date(DropTimeClub) && document.getElementById("TabelleCount") != null) 
                        
                      {
                        //alert(document.getElementById("TabelleCount"));
                        document.getElementById("TabelleCount").style.display = "inline";}          
          
          //Eintragen Zeiten in Timer
                  var countDownDate = new Date(DropTimeClub).getTime();
                  var x = setInterval(function() {
                  var now = new Date().getTime();
                  var distance = countDownDate - now;
                 
          
          
            //WEnn Zeit abgelaufen ist
                  if (distance <= 0) {
                        //clearInterval(x);
                        //Blendet Knöpfe ein nach der Zeit 
                        let fLen = knoepfe.length;
                        for (let i = 0; i < fLen; i++) {
                           links[knoepfe[i]].style.display="inline";        
                        }  
                      
                        document.getElementById("ausblenden").style.display = "none";
                        document.getElementById("einblenden").style.display = "block"; ; 
                        document.getElementById("einblenden").style.animation= "fadeIn 2s";
                        document.getElementById("einblenden2").style.display= "block";
                        
                  }
          else{
          
                     //Blendet Knöpfe zum Produkt aus vor der Zeit 
                       // let fLen = knoepfe.length;
                       // for (let i = 0; i < fLen; i++) {
                       //    links[knoepfe[i]].style.visibility="hidden";         
                        //}
                    
                      document.getElementById("TitelZeit").innerHTML = TextUeberschrift;
                      document.getElementById("ausblenden").style.display = "block";
                      document.getElementById("ausblenden").style.animation= "fadeIn 2s";    
            }
          
          // Time calculations for days, hours, minutes and seconds
                    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
            // Display the result in the element with id="demo"
          //  document.getElementById("demo").innerHTML = days + "d " + hours + "h "   + minutes + "m " + seconds + "s ";
                    if (days!=-1){
                    document.getElementById("Tage").innerHTML = days
                    document.getElementById("Stunden").innerHTML = hours 
                    document.getElementById("Minuten").innerHTML = minutes 
                    document.getElementById("Sekunden").innerHTML = seconds }
          
          
           }, 1000);

}
//Marks